import { Order } from '@spa/store/modules/orderHistory/types'
import { EligibilityChecker, EligibilityCheckStrategy } from './base'

export interface ContextForOrderLayer {
  order: Pick<Order, 'salesOrderStatus'>
}

export class EligibilityCheckerForOrderLayer extends EligibilityChecker<ContextForOrderLayer> {}

export class EligibleWhenOrderStatusIsNotPaymentRequested implements EligibilityCheckStrategy<ContextForOrderLayer> {
  check(context: ContextForOrderLayer): boolean {
    return context.order.salesOrderStatus !== 'payment-requested'
  }
}
